import { useField } from 'formik';
import React from 'react';
import { isReadOnly } from 'utilities/JSUtil';
import '../Form.scss';

const TextInput = ({ label, ...props }) => {
    const [field, meta, helpers] = useField(props);

    let classes

    if (props.prefix && props.suffix) {
        classes = 'form-input-value-with-prefix-and-suffix'
    } else if (props.prefix) {
        classes = 'form-input-value-with-prefix'
    } else if (props.suffix) {
        classes = 'form-input-value-with-suffix'
    } else {
        classes = 'form-input-value'
    }

    let requiredLabel = undefined
    let error = undefined

    if (props.isrequired === 'true') {
        requiredLabel = '*'
    } else if (props.isdependent === 'true') {
        requiredLabel = '**'
    }

    if (meta.error) {
        error = <div className='invalid'>{meta.error}</div>
    }

    return (
        <div id={props.id} className='form-input'>
            {
                props.prefix
                && <div className='form-input-value-prefix'>{props.prefix}</div>
            }
            {label && <div className='form-input-label'>
                <label htmlFor={props.name}>
                    {label}{requiredLabel}
                </label>
            </div>
            }
            <div className={classes}>
                <input {...field} {...props} title={props.title || label} autoComplete="off" noValidate disabled={props.overridedisabledflag === 'true' ? false : (isReadOnly() || props.disabled)} />
                {error}
            </div>
            {
                props.suffix
                && <div className='form-input-value-suffix'>{props.suffix}</div>
            }
        </div>
    );
};

export default TextInput